import { render, staticRenderFns } from "./AddNewComplex.vue?vue&type=template&id=b3de12a2&scoped=true"
import script from "./AddNewComplex.vue?vue&type=script&lang=js"
export * from "./AddNewComplex.vue?vue&type=script&lang=js"
import style0 from "./AddNewComplex.vue?vue&type=style&index=0&id=b3de12a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3de12a2",
  null
  
)

export default component.exports